var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 10.8335C8.69119 11.3119 9.14778 11.7078 9.6721 11.9943C10.1964 12.2807 10.7762 12.4511 11.3722 12.4937C11.9681 12.5364 12.5663 12.4504 13.1261 12.2416C13.6859 12.0328 14.1942 11.706 14.6166 11.2835L17.1166 8.78347C17.8756 7.99763 18.2956 6.94512 18.2861 5.85263C18.2766 4.76014 17.8384 3.71509 17.0659 2.94256C16.2934 2.17002 15.2483 1.73182 14.1558 1.72233C13.0633 1.71283 12.0108 2.13281 11.225 2.8918L9.79165 4.3168",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.16653C11.3088 8.68809 10.8522 8.29221 10.3279 8.00575C9.80353 7.71928 9.22373 7.54893 8.62777 7.50625C8.03182 7.46357 7.43366 7.54956 6.87386 7.75838C6.31406 7.9672 5.80572 8.29397 5.38332 8.71653L2.88332 11.2165C2.12432 12.0024 1.70435 13.0549 1.71384 14.1474C1.72334 15.2399 2.16154 16.2849 2.93407 17.0574C3.70661 17.83 4.75166 18.2682 5.84415 18.2777C6.93663 18.2872 7.98914 17.8672 8.77498 17.1082L10.2 15.6832",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d838725f9d95701f7071ccb2c64d47db.svg";
export { ForwardRef as ReactComponent };